import React from 'react';
import { Flex, Button } from '@decisiv/ui-components';

const GROUP_BYS = [
  { id: 'dealer', label: 'By Location' },
  { id: 'user', label: 'By User' },
];

// Full-page navigation with a `?group_by=` query param, same pattern as
// PeriodSelector — the controller re-renders fresh props (a different
// aggregate service and row shape), so no client-side fetch/state is needed.
// Switching groupBy resets q/search_field since the two modes search
// different fields (dealer id/name vs user id/email).
const GroupBySelector = ({ groupBy, basePath, period = 'day' }) => (
  <Flex gap={1} marginBottom={2}>
    {GROUP_BYS.map((g) => (
      <Button
        key={g.id}
        text={g.label}
        kind={g.id === groupBy ? 'primary' : 'secondary'}
        size="small"
        onClick={() => {
          const params = new URLSearchParams({ period, group_by: g.id });
          window.location.href = `${basePath}?${params.toString()}`;
        }}
      />
    ))}
  </Flex>
);

export default GroupBySelector;
